if (!customElements.get("product-tabs")) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");

      if (Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.querySelectorAll(".product__tab--trigger").forEach(
        tabTrigger => {
          tabTrigger.addEventListener("click", evt => {
            this.openTab(
              evt,
              tabTrigger.dataset.tab
            );
          });
        }
      );

      // Initial state should come from server-rendered markup to avoid delaying LCP.
      this.syncInitialStateFromMarkup();
    }

    syncInitialStateFromMarkup() {
      const triggers = Array.from(
        this.querySelectorAll(".product__tab--trigger")
      );
      if (!triggers.length) return;

      const defaultTrigger =
        this.querySelector(".product__tab--trigger.active") ||
        this.querySelector(".product__tab--trigger[data-default-open]") ||
        triggers[0];

      const tabName =
        defaultTrigger?.dataset?.tab ||
        defaultTrigger?.getAttribute("data-tab");

      // Ensure content visibility matches active trigger.
      const tabcontents = this.querySelectorAll(".product__tab-content");
      tabcontents.forEach(content => { content.hidden = true; });

      const currentTabContent = tabName
        ? this.querySelector(`#${tabName}`)
        : null;

      if (currentTabContent) currentTabContent.hidden = false;

      triggers.forEach(t => t.classList.toggle("active", t === defaultTrigger));
    }

    openTab(evt, tabName) {
      const tabcontents = this.querySelectorAll(
        ".product__tab-content"
      );
      tabcontents.forEach(content => { content.hidden = true; });

      const tablinks = this.querySelectorAll(".product__tab");
      tablinks.forEach(link => {
        link.classList.remove("active");
      });

      const currentTabContent = this.querySelector(`#${tabName}`);

      if (currentTabContent) {
        currentTabContent.hidden = false;
        if (evt.currentTarget) {
          evt.currentTarget.classList.add("active");
        }
      }
    }
  }
  customElements.define("product-tabs", ProductTabs);
}
